import { ViewportScroller } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-border-section',
  templateUrl: './border-section.component.html',
  styleUrls: ['./border-section.component.scss']
})
export class BorderSectionComponent implements OnInit {
  @Input() param: number = -1;
  @Input() isInnerBorder: boolean = false;
  @Input() sections: Section[] = [];
  @Input() isRevisionNoticesPage: boolean = false;

  alreadyScrolled: boolean = false;
  constructor(private scroller: ViewportScroller) {}

  ngOnInit(): void {
    // console.log('param : ', this.param);
  }

  isSelected(index: number) {
    const isSelected = this.param == index;
    if (isSelected && !this.alreadyScrolled) {
      this.scroller.scrollToAnchor('' + index);
      this.alreadyScrolled = true;
      // console.log(`scroll to this ${index}`);
    }
    return isSelected;
  }
}
